import ScreenSection from "../api/model/barrels/ScreenSection";

import { PartialScreen } from "./Screen";
import VariantGroupModel from "./VariantGroup";

enum MoveResourceType {
    Screen = "screen",
    VariantGroup = "variantGroup",
    Section = "section"
}

type MoveResourceScreen = PartialScreen & { type: MoveResourceType.Screen; };
type MoveResourceVariantGroup = VariantGroupModel & { type: MoveResourceType.VariantGroup; };
type MoveResourceSection = ScreenSection & { type: MoveResourceType.Section; };

type MoveResource = MoveResourceScreen | MoveResourceVariantGroup | MoveResourceSection;

export {
    MoveResourceType,
    MoveResourceScreen,
    MoveResourceVariantGroup,
    MoveResourceSection,
    MoveResource
};
